import * as THREE from "three";
import GlobalColorSingleton from "./GlobalColor";
import Letter from "./JumpingLetter";
export default class Errorsinterface {
  constructor(scene, errors_max = 5, xPosition = 0) {
    this.scene = scene;
    this.errors_max = errors_max;
    this.ERROR_COUNTER = 0;
    this.createErrorsObjects(xPosition);
  }

  createErrorsObjects(xPosition = 0) {
    this.errors = [];
    this.errors_group = new THREE.Group();
    this.errors_group.position.x = xPosition - ((this.errors_max - 1) * 20) / 2;
    // this.errors_group.position.y = -0.8;
    this.errors_group.position.z = -150;
    this.scene.add(this.errors_group);
    // for (let i = 0; i < this.errors_max; i++) {
    //   let error = Letter3D.set("+", 10, 1);
    //   error.position.x = i * 20;
    //   error.rotation.x = i == 0 ? 0 : -Math.PI / 2;
    //   error.rotation.z = Math.PI / 4;
    //   this.errors_group.add(error);
    //   this.errors.push(error);
    // }

    for (let i = 0; i < this.errors_max; i++) {
      setTimeout(() => {
        // create letter3D with a small size +
        let error = new Letter(null);
        error.position.x = i * 20;
        error.setSpecialCharacter("+", 10, 1, {
          x: Math.PI / 2,
          y: 0,
          z: Math.PI / 4,
        });
        this.errors_group.add(error);
        this.errors.push(error);
        error.jump();
      }, 100 * i);
    }
  }

  error() {
    // if (this.errors.length > 0) {
    if (this.ERROR_COUNTER < this.errors_max) {
      let error = this.errors.shift();
      error.setfullColor("0xff0000");
      error.pop();
      this.errors.push(error);
      this.ERROR_COUNTER++;
    }
  }
}
